import * as React from 'react';
import { format, parse } from "date-fns";

import { Segment } from "@independent-software/typeui/controls/Segment";
import { Number } from '@independent-software/typeui/formatters/Number';
import { Label } from '@independent-software/typeui/controls/Label';

import { Parameter } from '../../resource';

interface IProps {
  active?: boolean;
  payload?: any[];
  label?: string;
  parameter: Parameter;
}

const CustomTooltip = (props: IProps) => {
  if(props.active && props.payload && props.payload.length) {
    return <>
      <Segment tight attached="top" secondary>
        {format(parse(props.label, "t", new Date()), "d MMM yyyy")}
      </Segment>
      <Segment attached>
        {props.parameter.name}
      </Segment>
      <Segment attached="bottom">
        {props.payload.map((p:any, idx:number) => 
          <div key={idx}>
            <Label color={p.color}>{p.name}</Label>
            <Label basic><Number value={p.payload.value} decimals={props.parameter.decimals}/> {props.parameter.unit}</Label>
          </div>
        )}
      </Segment>
    </>
  }
  return null;
}

export { CustomTooltip }
